import React from "react";

// routing
import { Link } from "react-router-dom";

// component
import Badge from "../bradge/Badge";

const ConversationItem = ({ item, showSidebar }) => {
  return (
    <Link
      to={item.href}
      className="pl-1 text-base text-white flex items-center hover:opacity-90 transition-all"
    >
      <div className="relative w-[28px] flex items-center">
        {item.icon}

        {item.count > 0 && (
          <div className="absolute -top-2 -right-[1px]">
            <Badge
              count={item.count}
              classes={` ${item.count > 99 ? "w-[24px] -right-[5px]" : ""}`}
              innerClasses={`text-[10px] font-bold ${
                item.count > 99 ? "w-[24px] rounded-xl" : ""
              }`}
            />
          </div>
        )}
      </div>

      <div
        className={`ml-2 ${
          showSidebar ? "inline-flex" : "hidden"
        } items-center menu-label`}
        style={{ whiteSpace: "nowrap" }}
      >
        {item.name}
      </div>
    </Link>
  );
};

export default ConversationItem;
